import matchHeight from "jquery-match-height";

(() => {
  const slickInit = {
    init() {
      this.productSliderItems();
    },
    productSliderItems() {
      const productItems = $(
        ".c-box-top-products__slider .c-single-loop-procuct__link"
      );

      productItems.matchHeight();
    }
  };

  slickInit.init();
})();
